<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type { QTableProps } from 'quasar';

//eslint-disable-next-line no-undef
defineProps<{
  headers?: QTableProps['columns'],
  slotNames?: []
  dense?: boolean,
  hidePagination?: boolean,
  loading?: boolean,
  initialPagination?: QTableProps['pagination']
}>();

const rows = ref([]);

const tableRef = ref();
const filter = ref('');

onMounted(() => {
  tableRef.value.requestServerInteraction();
});
</script>

<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <q-table
    ref="tableRef"
    :dense="dense"
    :rows="rows"
    :columns="headers"
    :loading="loading"
    :filter="filter"
    :hide-pagination="hidePagination"
    :rows-per-page-options="[10, 20, 50]"
    :pagination="initialPagination"
  >
    <template
      v-for="slotName of slotNames"
      #[`body-cell-${slotName}`]="item"
    >
      <slot
        :key="slotName"
        :name="slotName"
        :row-item="item"
      />
    </template>
    <template #body-cell-action="item">
      <q-td
        style="width:200px"
        class="text-center"
      >
        <slot
          name="action"
          :row-item="item.row"
        />
      </q-td>
    </template>
  </q-table>
</template>

<style lang="sass">
.sticky-header
  height: 80vh
  tr th
    position: sticky
    z-index: 2
    background: #e1f5fe
  thead tr:last-child th
    z-index: 3
  thead tr:first-child th
    top: 0
    z-index: 1
  tr:first-child th:first-child
    z-index: 3
  td:first-child
    z-index: 1
  td:first-child, th:first-child
    position: sticky
    left: 0
</style>